import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { usePermissions } from '@/app/hooks/usePermissions';
import { loadEarnings } from '@/modules/earning/actions/async/load-earnings';
import { TPeriodName, PeriodNameEnum } from '@/modules/earning/model';
import { getEarnings, getInterval } from '@/modules/earning/store/selectors';
import { AppDispatch } from '@/root-store';

import { View } from './view';

const List = () => {
  const dispatch: AppDispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  usePermissions('viewOverview');

  const earnings = useSelector(getEarnings);
  const interval = useSelector(getInterval);

  const fetchEarnings = useCallback(
    ({ periodName }: { periodName?: string }) => {
      setIsLoading(true);
      dispatch(
        loadEarnings({
          periodName: (periodName as TPeriodName) ?? PeriodNameEnum.last_week,
        }),
      )
        .unwrap()
        .finally(() => {
          setIsLoading(false);
        });
    },
    [dispatch, setIsLoading],
  );

  return (
    <View
      earnings={earnings}
      interval={interval}
      fetchEarnings={fetchEarnings}
      isLoading={isLoading}
    />
  );
};

export { List };
